import { Component, input } from '@angular/core';

@Component({
    selector: 'baas-offcanvas-pane',
    templateUrl: './baas-offcanvas-pane.html',
    host: { class: 'lv-offcanvas-pane' }
})
export class BaasOffcanvasPane {
    readonly title = input.required<string>();
    readonly titleIconClass = input<string>();
}
